export const isFullStatic = false
export const staticPath = "/home/runner/work/sokusai-lab-nuxt/sokusai-lab-nuxt/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"